import React from 'react';
import './styles.scss';

const FileAssets = ({ block }) => {
  const { previewImage, asset } = block;

  return (
    <div className="file-assets-block">
      <a href={asset.url} target="_blank" rel="noopener noreferrer">
        {previewImage ? <img src={previewImage.url} alt={previewImage.alt} /> : 'Download File'}
      </a>
    </div>
  );
};

export default FileAssets;
